/** Keep a dragged panel within its workspace without snapping to table rows. */
export function getDraggedBottomPanelHeight(
  startHeight: number,
  startY: number,
  currentY: number,
  min: number,
  max: number,
): number {
  return Math.min(max, Math.max(min, startHeight - (currentY - startY)));
}
